/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypeother2Inputs */

const zh_learn_mistakestypeother2 = /** @type {(inputs: Learn_Mistakestypeother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const en_learn_mistakestypeother2 = /** @type {(inputs: Learn_Mistakestypeother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const es_learn_mistakestypeother2 = /** @type {(inputs: Learn_Mistakestypeother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Learn_Mistakestypeother2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypeother2 = /** @type {((inputs?: Learn_Mistakestypeother2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypeother2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypeother2(inputs)
	if (locale === "en") return en_learn_mistakestypeother2(inputs)
	return es_learn_mistakestypeother2(inputs)
});
export { learn_mistakestypeother2 as "learn_mistakesTypeOther" }